import React from 'react';
import { Button, makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      color: theme.palette.primary.main,
      minWidth: theme.spacing(10),
    },
  }),
);

const SecondaryButton: React.FC<any> = (props) => {
  const { children, ...rest } = props;
  const classes = useStyles();
  return (
    <Button
      variant='outlined'
      color='primary'
      className={classes.container}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
